import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import {Curso} from '../../modelos/curso';

@Component({
  selector: 'app-cursos',
  templateUrl: './cursos.component.html',
  styleUrls: ['./cursos.component.css']
})
export class CursosComponent implements OnInit {

  public cursos: Array<Curso>;
  

  constructor(
    private _route: ActivatedRoute,
    private _router: Router
  ) { 
    this.cursos = [
      new Curso ("Activador Akashico® Luz Ilimitada®","/curso/aali"),
      new Curso ("Activador Akashico® II","/curso/aa2"),
      new Curso ("Activador Akashico® Cristales","/curso/aac"),
      new Curso ("Conexión NeuroAkashico®","/curso/cn"),
      new Curso ("Expandia","/curso/exp"),
      new Curso ("Expansión del Ser (21 días)","/curso/p21es"),
      new Curso ("NeuroAkashico® Gran Sistema de Redes","/curso/nags"),
      new Curso ("Conexión Akashico®","/curso/ca"),
      new Curso ("Sistema de Redes NeuroAkashico®","/curso/srn"),
      new Curso ("NeuroAkashico® el Gran Observador (Master Class)","/curso/ngo"),
      
     
     
      ];
  }

  ngOnInit(): void {
  }

}
